// extracted by mini-css-extract-plugin
export default {"InputRecoveryContainer":"InputRecovery_InputRecoveryContainer__n-+UG","InputRecovery":"InputRecovery_InputRecovery__GuOZV","InputError":"InputRecovery_InputError__w55jq"};